module.exports = __webpack_public_path__ + "static/media/logo.1568467b.svg";